import { createSelector } from 'reselect';
import Immutable from 'immutable';
import { selectUGCByType, selectUGCListByUsers, selectUGCByBibs } from './UGCBaseSelector';

const getTransactions = state => state.getIn(['ugc', 'tagsTransactions'], Immutable.Map());

export const selectTags = selectUGCByType('tags');
export const selectTagsByUsers = selectUGCListByUsers('tags');
export const selectTagsByBibs = selectUGCByBibs('tags');

export const selectTagsTransactions = createSelector([getTransactions], transactions => transactions);

// Tag Summaries
const getTagSummaries = state => state.getIn(['ugc', 'tags', 'summaries'], Immutable.List());
export const selectTagSummariesByBib = createSelector([getTagSummaries], tags => tags);

export default {
  selectTags,
  selectTagsByUsers,
  selectTagsByBibs,
  selectTagsTransactions,
  selectTagSummariesByBib
};
